import { z } from 'zod';

export type UpdateMyPlayerPayload = z.output<typeof updateMyPlayerPayloadSchema>;
export type UpdateMyPlayerPayloadDTO = z.input<typeof updateMyPlayerPayloadSchema>;

/**
 * What a player user may change on their own roster entry.
 */
export const updateMyPlayerPayloadSchema = z.object({
  /** The email where automated reports are sent. */
  email: z.email().nullable().optional(),
  /**
   * Whether automated reports are emailed at all.
   *
   * Independent of the text message opt-in, which is not part of this payload: consent has to be
   * recorded with the number it was given for, so it goes through its own route.
   */
  enableNotifications: z.boolean().optional(),
  /** The roster first name. */
  firstName: z.string().trim().min(1).optional(),
  /** Height in centimetres. */
  height: z.number().min(100).max(250).nullable().optional(),
  /** The roster last name. */
  lastName: z.string().trim().min(1).optional(),
  /** Weight in kilograms. */
  weight: z.number().min(25).max(250).nullable().optional(),
});
